/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileCertification } from '../../models/profile-certification';

export interface ListProfileCertification$Params {

/**
 * ID of profile to which will be certifications listed
 */
  id: number;
}

export function listProfileCertification(http: HttpClient, rootUrl: string, params: ListProfileCertification$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileCertification>>> {
  const rb = new RequestBuilder(rootUrl, listProfileCertification.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProfileCertification>>;
    })
  );
}

listProfileCertification.PATH = '/rest/profile/{id}/certification';
